import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { useClientId } from '../../../../../../_hooks/useClientId';
import { BeFi20Icon } from '../../../../../../BeFi20/img/BeFi20Icon';
import { useBeFi20CardQuery } from '../../../../../api/useBeFi20CardQuery';
import {
  selectHasBeFi20,
  selectHasMobileNavigation,
} from '../../../../../../CommonSelectors/CommonAreaSelector';
import { GoalCard } from '../GoalCard/GoalCard';
import { GoalCardError } from '../GoalCard/GoalCard.error';
import { GoalCardLoading } from '../GoalCard/GoalCard.loading';

export const BeFi20Card = () => {
  const hasBeFi20 = useSelector(selectHasBeFi20);

  if (!hasBeFi20) {
    return null;
  }

  return <Card />;
};

const Card = () => {
  const hasMobileNavigation = useSelector(selectHasMobileNavigation);

  const { data, isLoading, error, refetch } = useBeFi20CardQuery();

  const clientId = useClientId();

  if (isLoading) {
    return <GoalCardLoading />;
  }

  if (error) {
    return <GoalCardError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { persona, isCompleted } = data;

  return (
    <GoalCard
      title="BeFi20"
      icon={<BeFi20Icon />}
      showCompletedLozenge
      isCompleted={isCompleted}
      ctaText={isCompleted ? 'View or share your Assessment' : 'Complete Your Assessment'}
      hideFooter={hasMobileNavigation}
      onClick={() => {
        if (!hasMobileNavigation) {
          if (isCompleted) {
            ADV.util.Router.go2('BeFi20Overview', { clientId });
          } else {
            ADV.util.Router.go2('BeFi20Workflow', { clientId });
          }
        }
      }}
    >
      <Text>{persona || 'You are almost there!'}</Text>
    </GoalCard>
  );
};
